import { render, staticRenderFns } from "./subbrandConfigForm.vue?vue&type=template&id=77d5802a&scoped=true"
import script from "./subbrandConfigForm.vue?vue&type=script&lang=js"
export * from "./subbrandConfigForm.vue?vue&type=script&lang=js"
import style0 from "./subbrandConfigForm.vue?vue&type=style&index=0&id=77d5802a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d5802a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/build/src/oncheckbuild_FutureGAJDKUpgrade90d6697d/FL2FL3nodefinapp/subbrandtool/client/1.0/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VBtn,VFlex,VLayout})
